import storageService from './storage.js';

/**
 * Service class for glp1 treatment.
 */
export default function glp1TreatmentService() {
  const glp1_treatment_type = 'glp_1';

  /**
   * Check if the current treatment type is GLP-1.
   */
  function isGlp1TreatmentType() {
    return storageService().treatmentType === glp1_treatment_type;
  }

  return {
    isGlp1TreatmentType,
  };
}
